import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Typography, Box, Button } from "@mui/material";
import * as kRoutes from "../../../../constants/routes";
import AfinandinhoCheck from "../../../../assets/images/afinandinho_check.svg";
import CloseIcon from "@mui/icons-material/Close";

const ModalLimitPlaysTest = ({
  openModalQuiz,
  setOpenModal,
  setOpenGame = () => {},
  setInfoActivity,
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const styleButton = {
    width: { xs: "298px", sm: "416px" },
    padding: "8px 16px",
    borderRadius: "30px",
    textAlign: "center",
    fontWeight: 600,
    textTransform: "uppercase",
  };

  const styleTypography = {
    marginTop: "30px",
    color: "#666",
    textAlign: "center",
    fontWeight: 400,
    fontSize: { xs: "0.9rem", sm: "1rem" },
  };

  //Ação do botão jogar sem limites
  const handleUpgradePlan = () => {
    setInfoActivity(false)
    setOpenModal(false);
    setOpenGame(null);
    navigate(kRoutes.R_BUY);
  };

  if (!openModalQuiz) return null;

  return (
    <Box
      sx={{
        opacity: 1,
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: "#2A133C85",
        backdropFilter: "blur(6px)", // efeito de desfoque
        WebkitBackdropFilter: "blur(6px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 20000,
      }}
    >
      <Box
        sx={{
          width: { xs: "345px", sm: "543px" },
          height: "620px",
          background: "#FEFEFE",
          borderRadius: "15px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-around",
            width: "100%",
            height: "77px",
            textAlign: "center",
            borderRadius: "15px",
            background: "#EEE8F266",
            color: "#662D91",
          }}
        >
          <Box>
            <Typography
              sx={{ fontSize: { xs: "1rem", sm: "1.1rem" }, fontWeight: 600 }}
            >
              {t("global.today_workout_is_complete")}
            </Typography>
          </Box>
          <Box>
            <CloseIcon
              onClick={() => {
                setOpenModal(false);
                setOpenGame(null);
              }}
              sx={{ cursor: "pointer", color: "#666" }}
            />
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginBottom: "20px",
          }}
        >
          <Box sx={{ width: { xs: "90%", sm: "380px" } }}>
            <Typography sx={styleTypography}>
              {t("global.you_have_completed_the_three_daily_sessions")}
            </Typography>
          </Box>
          <Box>
            <img src={AfinandinhoCheck} alt="Treino concluído" />
          </Box>
          <Box sx={{ width: { xs: "90%", sm: "450px" }, marginBottom: "20px" }}>
            <Typography sx={styleTypography}>
              {t("global.continue_tomorrow_or_play_without_limits")}
            </Typography>
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 2,
          }}
        >
          <Button
            sx={{
              ...styleButton,
              border: "2px solid #7B2CBF",
              background: "#7B2CBF",
              ":hover": {
                background: "#5e2391",
              },
            }}
            variant="contained"
            onClick={() => {
              handleUpgradePlan();
            }}
          >
            {t("global.play_without_limits")}
          </Button>
          <Button
            sx={{
              ...styleButton,
              border: "2px solid #662D91",
              background: "#FDFDFD",
              ":hover": {
                background: "#662d912c",
                boxShadow: "0px 2px 6px #662d912c",
              },
            }}
            variant="outlined"
            onClick={() => {
              setOpenModal(false);
              setOpenGame(null);
            }}
          >
            {t("global.come_back_tomorrow")}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default ModalLimitPlaysTest;
